import React, { FC, MouseEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logUserFirstInteraction } from '~/actions/widgetContextActions';
import { IState } from '~/sharedInterfaces/IState';
import { getInputClassNames } from '~/utils';
import { getDefaultLabelName } from '../../../services/DefaultLabelNameService';
import { IBaseComponent } from '../../../sharedInterfaces/IBaseComponent';

interface IButtonProps extends IBaseComponent {
  label?: string;
  disabled?: boolean;
  loading?: boolean;
  onClick: (event: MouseEvent<HTMLInputElement>) => void;
}

const Button: FC<IButtonProps> = ({
  componentName,
  label,
  disabled = false,
  onClick,
  loading = false,
}) => {
  const { locale } = useSelector((state: IState) => state.widgetContext);
  const buttonLabel = label || getDefaultLabelName(locale, componentName).label;
  const dispatch = useDispatch();

  const handleOnClick = (event: MouseEvent<HTMLInputElement>) => {
    if (onClick) onClick(event);

    dispatch(logUserFirstInteraction());
  };

  return (
    <div
      className={getInputClassNames({
        loading,
        tooltip: false,
        disabled,
        componentName,
        additionalClassName: 'qred-button',
      })}
    >
      <div className="qred-group">
        <div className="qred-row">
          <input type="button" onClick={handleOnClick} value={buttonLabel as string} />
        </div>
      </div>
    </div>
  );
};

export default Button;
